import type { SafeError, SafePromise } from '@benzinga/safe-await';
import type { Session } from '@benzinga/session';
import { ExtendedSubscribable } from '@benzinga/subscribable';

import type { EdgeContentResponse } from './entities';
import { EdgeRestful } from './restful';

interface ErrorEvent {
  error: SafeError;
  errorType: 'edge:get_content_error';
  type: 'error';
}

interface EdgeContentEvent {
  edgeContent: EdgeContentResponse;
  type: 'edge:get_content';
}

export type EdgeRequestEvent = ErrorEvent | EdgeContentEvent;

interface EdgeFunctions {
  getEdgeContent: EdgeRequest['getEdgeContent'];
}

export class EdgeRequest extends ExtendedSubscribable<EdgeRequestEvent, EdgeFunctions> {
  private restful: EdgeRestful;

  constructor(session: Session) {
    super();
    this.restful = new EdgeRestful(session);
  }

  public getEdgeContent = async (): SafePromise<EdgeContentResponse> => {
    const response = await this.restful.getEdgeContent();
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'edge:get_content_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        edgeContent: response.ok,
        type: 'edge:get_content',
      });
    }
    return response;
  };

  protected onSubscribe(): EdgeFunctions {
    return {
      getEdgeContent: this.getEdgeContent,
    };
  }
}
